
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/password_remind",
      function () {
        return require("private-next-pages/password_remind/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/password_remind"])
      });
    }
  